import { render, staticRenderFns } from "./modalEditRoster.vue?vue&type=template&id=4c0d9be6&"
import script from "./modalEditRoster.vue?vue&type=script&lang=js&"
export * from "./modalEditRoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports